module.exports = __webpack_public_path__ + "media/images/emblems/Samedan_wappen-88c91108a3b91483576864190233c795.svg";